import {
    ApplyScheduleTemplateBody,
    ApplyScheduleTemplateResponse,
} from "@common/schemas/domains/accounting/scheduleApplication.schema";
import { ScheduleSourceType } from "@common/types/domains/accounting/schedule";
import { Transaction } from "@common/types/transaction";
import { TransactionSplitFormRow } from "./transactionSplitUtils";

export function matchSavedSplit(params: {
    formSplit: TransactionSplitFormRow;
    formSplits: TransactionSplitFormRow[];
    savedSplits: Transaction[];
}): Transaction | undefined {
    const { formSplit, formSplits, savedSplits } = params;
    if (formSplit.id != null) {
        return savedSplits.find((split) => split.id === formSplit.id);
    }

    const reservedIds = new Set(
        formSplits
            .map((row) => row.id)
            .filter((id): id is number => id != null),
    );
    const unmatchedSaved = savedSplits.filter(
        (split) => !reservedIds.has(split.id),
    );
    const newFormIndex = formSplits
        .filter((row) => row.id == null)
        .indexOf(formSplit);
    if (newFormIndex < 0) {
        return undefined;
    }
    return unmatchedSaved[newFormIndex];
}

export async function applySplitSchedules(params: {
    formSplits: TransactionSplitFormRow[];
    savedTransaction: Transaction;
    apply: (options: {
        templateId: string;
        payload: ApplyScheduleTemplateBody;
    }) => Promise<ApplyScheduleTemplateResponse>;
}): Promise<void> {
    const { formSplits, savedTransaction, apply } = params;
    const savedSplits = savedTransaction.splits ?? [savedTransaction];

    for (const formSplit of formSplits) {
        const templateId = formSplit.scheduleTemplateId;
        if (!templateId) {
            continue;
        }
        const savedSplit = matchSavedSplit({
            formSplit,
            formSplits,
            savedSplits,
        });
        if (!savedSplit) {
            continue;
        }
        const amount = Math.abs(savedSplit.amount);
        if (amount === 0) {
            continue;
        }
        await apply({
            templateId,
            payload: {
                sourceType: ScheduleSourceType.transaction,
                entityId: savedSplit.entity.id,
                transactionId: savedSplit.id,
                amount,
            },
        });
    }
}
